'use client';

const clients = [
  { name: 'CBRE', style: 'font-bold tracking-tight text-lg' },
  { name: 'Cisco', style: 'font-semibold tracking-wide text-base' },
  { name: 'JP Morgan Chase', style: 'font-medium tracking-tight text-sm' },
  { name: 'Mercedes-Benz R&D', style: 'font-semibold tracking-wider text-sm' },
  { name: 'ITC Hotels', style: 'font-bold tracking-widest text-sm' },
  { name: 'Cognizant', style: 'font-semibold tracking-wide text-base' },
  { name: 'GE', style: 'font-bold tracking-tight text-2xl' },
  { name: 'Accenture', style: 'font-semibold tracking-wide text-base' },
  { name: 'Oracle', style: 'font-bold tracking-tight text-lg' },
  { name: 'Dell', style: 'font-bold tracking-widest text-lg' },
  { name: 'Embassy Tech Parks', style: 'font-medium tracking-wide text-sm' },
  { name: 'Prestige', style: 'font-semibold tracking-wider text-base' },
  { name: 'Biocon', style: 'font-bold tracking-wide text-base' },
  { name: 'Goldman Sachs', style: 'font-medium tracking-tight text-sm' },
  { name: 'Quest', style: 'font-bold tracking-widest text-base' },
];

export default function ClientMarquee() {
  // Duplicate for seamless loop
  const items = [...clients, ...clients];

  return (
    <>
      <style data-component-id="src/app/homepage/components/ClientMarquee.tsx:27:6" data-component-path="src/app/homepage/components/ClientMarquee.tsx" data-component-line="27" data-component-end-line="119" data-component-file="ClientMarquee.tsx" data-component-name="style" data-component-content="%7B%22elementName%22%3A%22style%22%7D">{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400&display=swap');

        .pf-marquee-section {
          background: var(--color-background, #fff);
          border-top: 1px solid var(--color-border, #e7e5e0);
          border-bottom: 1px solid var(--color-border, #e7e5e0);
          padding: 0;
          overflow: hidden;
          position: relative;
        }

        /* fade edges */
        .pf-marquee-section::before,
        .pf-marquee-section::after {
          content: '';
          position: absolute;
          top: 0; bottom: 0;
          width: 120px;
          z-index: 2;
          pointer-events: none;
        }
        .pf-marquee-section::before {
          left: 0;
          background: linear-gradient(to right, var(--color-background, #fff), transparent);
        }
        .pf-marquee-section::after {
          right: 0;
          background: linear-gradient(to left, var(--color-background, #fff), transparent);
        }

        .pf-marquee-label {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 3;
          background: var(--color-background, #fff);
          padding: 0 20px;
          font-family: 'Cormorant Garamond', serif;
          font-size: 11px;
          font-weight: 400;
          font-style: italic;
          letter-spacing: 0.12em;
          color: var(--color-muted-foreground, #78716c);
          white-space: nowrap;
          pointer-events: none;
        }

        .pf-marquee-track {
          display: flex;
          align-items: center;
          gap: 0;
          width: max-content;
          animation: pf-scroll 40s linear infinite;
          padding: 20px 0;
        }
        .pf-marquee-track:hover { animation-play-state: paused; }

        @keyframes pf-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        .pf-marquee-item {
          display: flex;
          align-items: center;
          gap: 0;
          white-space: nowrap;
          padding: 0 40px;
          position: relative;
          color: var(--color-muted-foreground, #78716c);
          transition: color 0.2s ease;
          cursor: default;
          font-family: 'DM Sans', sans-serif;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }
        .pf-marquee-item:hover {
          color: var(--color-foreground, #1c1917);
        }

        /* dot separator */
        .pf-marquee-item::after {
          content: '·';
          position: absolute;
          right: 0;
          color: var(--color-border, #e7e5e0);
          font-size: 20px;
          line-height: 1;
          pointer-events: none;
        }
      `}</style>

      <section data-component-id="src/app/homepage/components/ClientMarquee.tsx:121:6" data-component-path="src/app/homepage/components/ClientMarquee.tsx" data-component-line="121" data-component-end-line="129" data-component-file="ClientMarquee.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22pf-marquee-section%22%7D" className="pf-marquee-section">
        <div data-component-id="src/app/homepage/components/ClientMarquee.tsx:122:8" data-component-path="src/app/homepage/components/ClientMarquee.tsx" data-component-line="122" data-component-end-line="128" data-component-file="ClientMarquee.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pf-marquee-track%22%7D" className="pf-marquee-track">
          {items.map((client, i) => (
            <span data-component-id="src/app/homepage/components/ClientMarquee.tsx:124:12" data-component-path="src/app/homepage/components/ClientMarquee.tsx" data-component-line="124" data-component-end-line="126" data-component-file="ClientMarquee.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" key={`${client.name}-${i}`} className={`pf-marquee-item ${client.style}`}>
              {client.name}
            </span>
          ))}
        </div>
      </section>
    </>
  );
}